module.exports = "//static.hsappstatic.net/LoginUI/static-1.16087/img/hubspotMobileApp2FA.png"